import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import DialogTitle from '../DialogTitle';
import DialogTransition from '../DialogTransition';

/**
 * プロパティ
 */
export type Props<T> = {
  /** Comp */
  comp: React.FC<{
    /** データ */
    data: T,
  }>,
  /** データ */
  data?: T,
  /** 閉じる */
  close: () => void,
  /** タイトル */
  title: string,
}

/**
 * 詳細
 * @param props プロパティ
 * @returns コンポーネント
 */
// eslint-disable-next-line comma-spacing
const Detail = <T,>(props: React.PropsWithChildren<Props<T>>) => {
  const {
    close,
    data,
    comp,
    title,
  } = props;
  return (
    <Dialog
      open={data !== undefined}
      onClose={() => close()}
      fullScreen
      TransitionComponent={DialogTransition}
    >
      <DialogTitle title={`${title}の詳細情報`} />
      <DialogContent>
        {data && comp({ data })}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => close()} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Detail;
